import { useQuery } from 'react-query';
import { getAll } from '@hotjar/webapp/domains/segments/api';
import type { UseQueryResult } from 'react-query';
import type { Segment } from '@hotjar/webapp/features/Recordings/types';
import { convertFromQueryToNewUiFormat } from '@hotjar/global-filters';
import { useCurrentSite } from '@hotjar/site';
import { isAllowed } from '@hotjar/webapp/domains/common/feature';
import { PREDEFINED_SEGMENTS, SEGMENTS_QUERY_KEY } from '../constant';

const CACHE_TIME = 1000 * 60 * 60 * 24; // 24h

export const useSegments = (siteId: number | undefined): UseQueryResult<Segment[], Error> => {
  const { data: currentSite } = useCurrentSite();

  return useQuery(`${SEGMENTS_QUERY_KEY}_${siteId}`, () => getAll(siteId as number), {
    cacheTime: CACHE_TIME,
    staleTime: CACHE_TIME,
    refetchOnWindowFocus: false,
    select: (data: Segment[]) => {
      const allowedSegments = [...(PREDEFINED_SEGMENTS as Array<Segment>), ...data].filter(
        (segment) => {
          const convertedSegments = convertFromQueryToNewUiFormat(segment.filters);
          return convertedSegments.filterList.every((oneFilter) => {
            return isAllowed(`filters.${oneFilter.kind}`, currentSite || null);
          });
        },
      );

      return allowedSegments;
    },
    enabled: !!siteId,
  });
};
